import SodSidePanelHistory from './SodSidePanelHistory';

export default SodSidePanelHistory;
